const isLocalhost =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname === "[::1]";

export function registerServiceWorker() {
  if (
    process.env.NODE_ENV !== "production" ||
    !("serviceWorker" in navigator)
  ) {
    return;
  }

  window.addEventListener("load", () => {
    const serviceWorkerUrl = `${process.env.BASE_URL}service-worker.js`;

    navigator.serviceWorker
      .register(serviceWorkerUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;

          if (!installingWorker) {
            return;
          }

          installingWorker.onstatechange = () => {
            if (
              installingWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              window.dispatchEvent(new CustomEvent("app-update-ready"));
            }
          };
        };
      })
      .catch((error) => {
        if (isLocalhost) {
          console.error("Service worker registration failed:", error);
        }
      });
  });
}
